module.exports = __webpack_public_path__ + "img/icon-active.b214bc77.png";